// extracted by mini-css-extract-plugin
export default {"messageForm":"reportmodal_messageForm__Qqudt","messageInput":"reportmodal_messageInput__04mYm","messageButton":"reportmodal_messageButton__BTIPL"};